import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { type TestIds, getTestProps } from '../../../../utils/testing.ts'
import { CardHeadingDescription } from './card-heading-description.tsx'
import { CardHeadingOverline } from './card-heading-overline.tsx'
import { CardHeadingTag } from './card-heading-tag.tsx'
import { CardHeadingTitle } from './card-heading-title.tsx'

export type CardHeadingProps = PropsWithChildren<
  {
    className?: string
  } & TestIds
>
const CardHeadingComponent = ({
  children,
  className,
  ...testIds
}: CardHeadingProps) => (
  <div
    className={cn('flex flex-col items-start gap-2', className)}
    {...getTestProps(testIds)}
  >
    {children}
  </div>
)

const CardHeadingNamespace = Object.assign(CardHeadingComponent, {
  Description: CardHeadingDescription,
  Overline: CardHeadingOverline,
  Tag: CardHeadingTag,
  Title: CardHeadingTitle,
})

export { CardHeadingNamespace as CardHeading }
